module.exports = __webpack_public_path__ + "img/9788997980291.6c8442e5.jpg";